(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mediatech-home-video"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (scope) => {
      scope.querySelectorAll('.mt-home-film__video').forEach((video) => {
        if (video.dataset.mtFilmInitialized) return;
        video.dataset.mtFilmInitialized = 'true';
        video.controls = false;
        video.defaultMuted = true;
        video.muted = true;
        video.volume = 0;
        video.disablePictureInPicture = true;
        video.disableRemotePlayback = true;
        const play = () => {
          if (document.hidden) return;
          const playback = video.play();
          if (playback && typeof playback.catch === 'function') playback.catch(() => {});
        };
        video.addEventListener('loadeddata', play, { once: true });
        if (video.readyState >= 2) play();
        document.addEventListener('visibilitychange', () => {
          const bounds = video.getBoundingClientRect();
          if (!document.hidden && bounds.top < window.innerHeight && bounds.bottom > 0) play();
        });
      });
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
    } else {
      initialize(document);
    }
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
